import ActiveRecord from './active_record/base'
import {alwaysDefinedArray} from '@eitje/utils'

class SkillSet extends ActiveRecord {
	static tableName = 'skillSets'

	static sort = ({name}) => {
		const normalizedName = name.toLowerCase()
		if (normalizedName === 'overig') return Number.POSITIVE_INFINITY
		return normalizedName
	}

	static useAll({ids, planning_active, team_ids} = {}) {
		let all = super.useAll()
		if (planning_active) all = all.filter(skillSet => skillSet.planning_active)
		if (ids || team_ids) {
			const teamIds = alwaysDefinedArray(team_ids)
			all = all.filter(
				skillSet => skillSet.team_ids.some(id => teamIds.includes(id)) || skillSet.team_ids.length === 0 || ids?.includes(skillSet.id),
			)
		}
		return all
	}
}

export default SkillSet
